import { render, staticRenderFns } from "./BondRecordAdd.vue?vue&type=template&id=04ffda26&scoped=true"
import script from "./BondRecordAdd.vue?vue&type=script&lang=js"
export * from "./BondRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./BondRecordAdd.vue?vue&type=style&index=0&id=04ffda26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffda26",
  null
  
)

export default component.exports